import PropTypes from 'prop-types';
import React from 'react';

import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/styles';


const useStyles = makeStyles(() => ({
  button: {
    minWidth: 24,
    width: 24,
    top: 10,
    marginLeft: 10,
  },
  formControl: {
    display: 'inline-block',
    marginTop: 20,
    marginBottom: 20,
  },
  textField: {
    width: 220,
  },
}));

const DecIncTextField = ({
   label,
   input: { name, value, onChange },
   meta: { touched, error },
}) => {
  const classes = useStyles();

  return (
    <FormControl error={touched && error} className={classes.formControl}>
      <TextField
        error={touched && error}
        className={classes.textField}
        name={name}
        label={label}
        value={value}
        onChange={(event) => {
          onChange(event.target.value);
        }}
      />

      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          let newValue = Number(value) - 1;

          if (newValue < 0) newValue = Number(0);

          onChange(newValue.toString());
        }}
        className={classes.button}
      >
        -
      </Button>

      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          let newValue = Number(value) + 1;

          onChange(newValue);
        }}
        className={classes.button}
      >
        +
      </Button>

      {(touched && error) && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

DecIncTextField.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.any,
  }).isRequired,
  meta: PropTypes.shape({
    error: PropTypes.string,
    touched: PropTypes.bool.isRequired,
    warning: PropTypes.string,
  }).isRequired,
};

export default DecIncTextField;
